<template>
  <IPhone
    style="height: calc(100vh - 78px); max-height: 895px;"
    @click-topbar="removeLastStack"
    :theme="navigationStack.length ? 'dark' : 'light'"
  >
    <div
      class="w-full flex flex-col flex-1 bg-white rounded-xl overflow-hidden transition-all duration-300 transform origin-bottom"
      :class="{
        'scale-92': navigationStack.length
      }"
    >
      <div class="flex-1 flex flex-col overflow-auto scrollbar-hide">
        <div class="pt-15 pb-10 space-y-6">
          <div v-for="(block, i) in mainPageBlocks" :key="i" class="block group">
            <h2
              v-if="block.title"
              class="text-base font-bold px-4 mb-3 whitespace-pre-line"
            >
              {{ block.title }}
            </h2>

            <block-group
              :kind="block.kind"
              :block="block"
              @click-item="handleClickBlockItem"
            />
          </div>
        </div>
      </div>
    </div>

    <transition-group name="slide-in-stack">
      <div
        v-for="(stack, i) in navigationStack"
        :key="'stack' + i"
        class="absolute z-1 bottom-0 left-0 flex w-full bg-white rounded-xl overflow-hidden transition-all duration-300"
        :class="{
          'transform origin-bottom scale-92 translate-y-0': stack.id !== navigationStack.at(-1).id
        }"
        :style="{
          'height': stack.id !== navigationStack.at(-1).id ? '100%' : 'calc(100% - 76px)'
        }"
      >
        <div v-if="stack.link" class="flex-1 flex relative z-1">
          <iframe :src="stack.link" class="flex-1 relative w-full h-full border-none" />

          <div class="absolute -z-1 inset-0 m-auto flex items-center justify-center">
            <uiLoader />
          </div>
        </div>

        <div v-else class="flex-1 overflow-auto scrollbar-hide">
          <div class="py-12 space-y-6">
            <div class="flex items-center px-4">
              <h2 class="text-xl font-bold mb-0 line-clamp-1">
                {{ stack.title }}
              </h2>
            </div>

            <div v-for="(block, i) in getPageBlocks(stack)" :key="i" class="block group">
              <h2
                v-if="block.title"
                class="text-base font-bold px-4 mb-3 whitespace-pre-line"
              >
                {{ block.title }}
              </h2>

              <block-group
                :kind="block.kind"
                :block="block"
                @click-item="handleClickBlockItem"
              />
            </div>
          </div>
        </div>
      </div>
    </transition-group>
  </IPhone>
</template>

<script>
import { ref, computed } from 'vue';
import IPhone from '@/components/IPhone.vue'
import BlockGroup from "../components/BlockGroup.vue";
import { useRouter, useRoute } from 'vue-router/composables';
import { useBlocks } from '../composables/blocks';
import { usePages } from '../composables/pages';
import { nanoid } from 'nanoid'

export default {
  components: {
    IPhone,
    BlockGroup,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const { blocks, getBlockById, blockKindMap } = useBlocks({ router, route })
    const { pages, mainPage, getPageById } = usePages({ router, route })

    function getPageBlocks(page) {
      if (!page) return []

      return page.blocks
        .map(id => {
          const block = getBlockById(id)
          if (block == null) return null

          return {
            ...block,
            kindLabel: blockKindMap[block.kind] ?? block.kind
          }
        })
        .filter(Boolean)
    }

    const mainPageBlocks = computed(() => getPageBlocks(mainPage.value))

    const navigationStack = ref([])

    function removeLastStack() {
      navigationStack.value.splice(-1)
    }

    function handleClickBlockItem(item) {
      if (item.link) {
        navigationStack.value.push({
          id: nanoid(),
          link: item.link
        })

        return
      }

      if (item.page) {
        const page = getPageById(item.page)
        navigationStack.value.push(page)
      }
    }

    return {
      blocks,
      pages,
      mainPage,
      mainPageBlocks,

      navigationStack,
      removeLastStack,

      getPageBlocks,
      handleClickBlockItem,
    }
  }
}
</script>

<style lang="postcss">
.slide-in-stack-enter-active, .slide-in-stack-leave-active {
  /* transition: opacity .5s; */
  /* @apply transition-all duration-30000; */
}
.slide-in-stack-enter, .slide-in-stack-leave-to {
  @apply transform translate-y-40 opacity-0;
}
</style>